import { createFileRoute, useRouteContext } from "@tanstack/react-router";
import { graphql, useLazyLoadQuery } from "react-relay";
import { Heading } from "@/components/heading";
import { Text } from "@/components/text";
import { Card } from "@/components/ui/card";
import type { pontuacao_PointsQuery } from "./__generated__/pontuacao_PointsQuery.graphql";
import { Skeleton } from "@/components/ui/skeleton";

export const Route = createFileRoute("/_visibility/_topnav/ranking/pontuacao")({
	component: RouteComponent,
	pendingMs: 300,
	pendingComponent: () => (
		<div className="w-full h-full flex items-center justify-center">
			<div className="flex flex-col w-full max-w-[900px] px-6">
				<Heading className="mt-6">Ranking</Heading>
				<Text>
					Cada vez que alguém realizar uma dessas ações, ele receberá a
					quantidade de pontos da direita
				</Text>

				<Skeleton className="w-full h-[480px] mt-6 mb-6" />
			</div>
		</div>
	),
});

function RouteComponent() {
	const { club } = useRouteContext({ from: "__root__" });
	const data = useLazyLoadQuery<pontuacao_PointsQuery>(
		graphql`
    query pontuacao_PointsQuery($slug: String!) {
      club(slug: $slug) {
        id
        ranking{
          events {
            name
            event
            enabled
            points
          }
        }
      }
    }
  `,
		{ slug: club?.slug || "" },
	);

	const events = data.club.ranking.events.filter((ev) => ev.enabled);

	return (
		<div className="w-full h-full flex items-center justify-center">
			<div className="flex flex-col w-full max-w-[900px] px-6">
				<Heading className="mt-6">Ranking</Heading>
				<Text>
					Cada vez que alguém realizar uma dessas ações, ele receberá a
					quantidade de pontos da direita
				</Text>

				<Card className="mt-6 mb-6 gap-0 py-0">
					{events.map((ev) => (
						<div
							key={ev.event}
							className="px-6 py-4 flex items-baseline justify-between border-b last:border-0"
						>
							<span className="font-medium">{ev.name}</span>

							<span className="font-medium">
								{ev.points}{" "}
								<span className="text-xs text-muted-foreground">pts</span>
							</span>
						</div>
					))}
				</Card>
			</div>
		</div>
	);
}
